import { useEffect, useRef } from "react";
import PageContainer from "@components/layout/PageContainer";
import { useNavigate } from "react-router-dom";
import ModelIndex, { ModelIndexHandle } from "@components/layout/ModelIndex";
import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { CreditOperatorApi, CreditOperatorDataType } from "@/api/CreditOperatorApi";
import { showAlert } from "@utils/Alert";
import { useAdminContext } from "@/hooks/useAdminContext";

const CreditOperatorsIndex = () => {
  const navigate = useNavigate();
  const modelRef = useRef<ModelIndexHandle>(null);
  const { adminTenantId, isAdminMode, profileBackUrl, adminQuerySuffix } = useAdminContext();

  useEffect(() => {
  }, []);

  const deleteRecord = async (id: string) => {
    const { errors } = await CreditOperatorApi.delete(id);
    if (errors?.length) {
      showAlert('danger', 'El Vendedor no puedo ser eliminado');
    } else {
      showAlert('success', 'El Vendedor fue eliminado correctamente');
    }
    modelRef.current?.refetch();
  }

  const fetchData = (...args: any[]) =>
    isAdminMode ? CreditOperatorApi.fetchAllByOwnerId(adminTenantId!) : CreditOperatorApi.fetchAll(...args);

  return (
    <PageContainer
      title="Operadores de Tarjeta"
      backUrl={profileBackUrl}
      primaryActions={[
        {
          onClick: () => {
            navigate(`/user/credit-operator${adminQuerySuffix}`)
          },
          actionTitle: "Nuevo",
          color: "success"
        }
      ]}
    >
      <ModelIndex<CreditOperatorDataType>
        ref={modelRef}
        fetchData={fetchData}
        filterProps={[
          {
            key: "codigo",
            filterType: "eq",
            type: "number"
          },
          {
            key: "nombre",
            filterType: "contains"
          }
        ]}
        secondaryProperties={[
          {
            key: "codigo",
          },
          {
            key: "nombre"
          }
        ]}
        listActions={[
          {
            href: `/user/credit-operator/{:id}${adminQuerySuffix}`,
            actionTitle: "Editar Operador de Tarjetas",
            iconProps: { icon: faEdit }
          },
          {
            actionTitle: "Eliminar Operador de Tarjetas",
            iconProps: { icon: faTrash },
            needConfirm: true,
            confirmProps: {
              title: "Eliminar Operador de Tarjeta",
              confirmMessage: "¿Seguro que desea eliminar este Operador de Tarjeta?",
              confirmBtnText: "Eliminar"
            },
            onClick: (id: string) => { deleteRecord(id) }
          }
        ]}
      >
      </ModelIndex>

    </PageContainer >
  );
}

export default CreditOperatorsIndex;
